import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { cn } from "@/lib/utils";

const KEY = "ph_favourites";
const EVENT = "ph:favourites";

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(v) ? v : []; } catch { return []; }
};

/** Favourite brand slugs, stored only in this browser (no account needed). */
export function useFavourites() {
  const [favs, setFavs] = useState(read);
  useEffect(() => {
    const sync = () => setFavs(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const toggle = (slug) => {
    const next = read().includes(slug) ? read().filter((s) => s !== slug) : [slug, ...read()];
    try { localStorage.setItem(KEY, JSON.stringify(next.slice(0, 50))); } catch { /* storage blocked */ }
    window.dispatchEvent(new Event(EVENT));
  };
  return { favs, isFav: (slug) => favs.includes(slug), toggle };
}

export function FavouriteButton({ brand, className, size = "md" }) {
  const { isFav, toggle } = useFavourites();
  const on = isFav(brand.slug);
  return (
    <button type="button" aria-pressed={on} aria-label={on ? `Remove ${brand.name} from favourites` : `Save ${brand.name} to favourites`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(brand.slug); }} data-testid={`favourite-btn-${brand.slug}`}
      className={cn("grid place-items-center rounded-full border transition-[background-color,border-color,color,transform] duration-300 active:scale-90",
        size === "lg" ? "h-12 w-12" : "h-10 w-10",
        on ? "border-rose-400/50 bg-rose-500/10 text-rose-500" : "border-ph-line bg-ph-surface text-ph-muted hover:border-rose-400/50 hover:text-rose-500", className)}>
      <Heart className={cn("h-4 w-4", on && "fill-current")} />
    </button>
  );
}
